import { render, staticRenderFns } from "./AccountOrderDetailsInfo.vue?vue&type=template&id=39b3765c&"
import script from "./AccountOrderDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./AccountOrderDetailsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports